<template>
  <div class="container">
    <div class="header">
      <div class="school">为您推荐</div>
      <div class="school">以下热门岗位/行业</div>
    </div>
    <div class="box-container flex">
      <div class="btn" v-for="(item, index) in list" :key="`btn_${index}`" @click="toLink(item)">{{ item.industry }}</div>
      <div class="pre-btn" @click="goBack">上一步</div>
    </div>
  </div>
</template>

<script>
// import api from '@/api'

export default {
  name: "active",
  data() {
    return {
      list: [
        {
          industry: '运营',
          url: ''
        },
        {
          industry: '四大咨询',
          url: ''
        },
        {
          industry: '数据分析',
          url: ''
        },
        {
          industry: '产品经理',
          url: ''
        },
        {
          industry: '金融券商',
          url: ''
        },
        {
          industry: '其他热门行业',
          url: ''
        }
      ]
    }
  },
  mounted() {
    this.getActiveLinks()
  },
  methods: {
    // 获取 admin 配置的链接
    getActiveLinks() {
      this.$api.cv.getQuestionnaire().then(res => {
        if (res.code === 1000) {
          let { result } = res.data
          if (this.$route.query.key === 'foreign') {
            this.list = result.filter(item => item.category === '海外院校页')
          } else {
            this.list = result.filter(item => item.category === '国内院校页')
          }
        }
      })
    },
    // 返货上一页
    goBack() {
      this.$router.go(-1)
    },
    // 链接跳转
    toLink(obj) {
      if (obj.url) {
        location.href = obj.url
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
  background: #F9F9F9;
  position: relative;
  .header {
    width: 100vw;
    height: 236px;
    padding: 36px 24px 0 24px;
    box-sizing: border-box;
    background: url('https://files.wondercv.com/APP/wenjuan_bg.png') no-repeat;
    background-size: 100% 100%;
    color: #fff;
    .school {
      font-size: 24px;
      font-weight: 600;
      &:last-child {
        margin-top: 10px;
      }
    }
  }
  .box-container {
    width: 327px;
    height: 338px;
    padding: 40px 30px;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 10px;
    justify-content: space-between;
    align-content: flex-start;
    flex-wrap: wrap;
    position: absolute;
    top: 135px;
    left: 24px;
    .btn {
      width: 128px;
      height: 52px;
      background: #F9F9F9;
      border-radius: 6px;
      text-align: center;
      line-height: 52px;
      font-size: 14px;
      font-weight: 500;
      color: #606060;
      margin-top: 16px;
      &:nth-child(1),&:nth-child(2) {
        margin-top: 0;
      }
    }
    .pre-btn {
      width: 100%;
      height: 20px;
      margin-top: 45px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: #9C9C9C;
    }
  }
}
</style>
